<lib-edl-cf-label [title]="model.config.title"></lib-edl-cf-label>
<paetep-signature formControlName="answer" [isPrintMode]="isPrintMode" [hideActionsWhenDisabled]="true">
    <div><span class="small">Signature of {{getSignatureTypeLabel()}}: {{signatureName}}</span></div>
    <div><span class="small">Sign Date: {{signatureDate | date}}</span></div>
</paetep-signature>
